import React from 'react';
import PropTypes from 'prop-types';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { connectSearchBox } from 'react-instantsearch-dom';
import Input from '../../Input';
import Button from '../../Button';
import Icon from '../../Icon';

const SearchBoxComp = ({ currentRefinement, refine, placeholder }) => (
  <form noValidate onSubmit={e => e.preventDefault()} role="search" className="mb-16">
    <div className="input-group">
      <Input
        type="search"
        name="search-demo"
        id="search-demo"
        value={currentRefinement}
        placeholder={placeholder}
        onChange={event => refine(event.currentTarget.value)}
      />
      <div className="input-group-append">
        <Button onClick={() => refine('')} type="button">
          <Icon icon={faTimes} />
        </Button>
      </div>
    </div>
  </form>
);

SearchBoxComp.propTypes = {
  currentRefinement: PropTypes.string,
  placeholder: PropTypes.string,
  refine: PropTypes.func,
};

SearchBoxComp.defaultProps = {
  currentRefinement: undefined,
  placeholder: undefined,
  refine: undefined,
};

export default connectSearchBox(SearchBoxComp);
